module.exports = __webpack_public_path__ + "img/whatsapp.ba0330c9.png";